export const wonCurrency = 'KRW';
